<div *ngIf="quota" class="quota-bar-container">
  <div class="quota-bar-header">
    <mat-icon class="quota-icon">send</mat-icon>
    <span class="quota-label">Monthly Image Transfers</span>
    <span class="quota-count">{{ quota.usageCount }} / {{ effectiveQuota }}</span>
    <span class="quota-percent"
          [class.warn]="percentage >= 90"
          [class.accent]="percentage >= 70 && percentage < 90">
      {{ percentage }}%
    </span>
  </div>
  <mat-progress-bar
    mode="determinate"
    [value]="percentage"
    [color]="barColor">
  </mat-progress-bar>
  <p *ngIf="percentage >= 100" class="quota-msg quota-exceeded">
    Quota reached — sends are blocked until next month.
  </p>
  <p *ngIf="percentage >= 70 && percentage < 100" class="quota-msg quota-warning">
    Approaching monthly limit.
  </p>
</div>
